/* global window, document, URL, Blob */

import * as R from 'ramda';

export default function ECATActiveAssessmentController(
  $filter,
  $q,
  $rootScope,
  $scope,
  confirmDialog,
  copy,
  orgDataService,
  ecatDataService,
  ecatSharedModelService,
  reportsDataService,
  loaderService,
  editAssessmentDialog,
  editInherentRiskProfileDialog,
  editMaturityProfileDialog,
  editCRIProfileDialog,
  editAssessmentDocumentDialog,
  performAssessmentDialog,
  ecatGenerateDocumentDialog,
  confirmCompleteAssessmentDialog,
  ssDialogService,
  userService,
  alerts,
) {
  const vm = this;

  vm.template = null;
  vm.hasData = false;
  vm.assessmentDetails = null;

  vm.isExpanded = false;
  vm.isInherentRiskProfileExpanded = false;
  vm.isMaturityProfileExpanded = false;
  vm.isCRIProfileExpanded = false;

  vm.handleExpandAssessment = _handleExpandAssessment;
  vm.handleEditAssessment = _handleEditAssessment;
  vm.handleDeleteAssessment = _handleDeleteAssessment;

  vm.handleExpandInherentRiskProfile = _handleExpandInherentRiskProfile;
  vm.handleEditInherentRiskProfile = _handleEditInherentRiskProfile;

  vm.handleExpandMaturityProfile = _handleExpandMaturityProfile;
  vm.handleEditMaturityProfile = _handleEditMaturityProfile;

  vm.handleExpandCRIProfile = _handleExpandCRIProfile;
  vm.handleEditCRIProfile = _handleEditCRIProfile;

  vm.handleAttachDocument = _handleAttachDocument;
  vm.handleDownloadAllDocuments = _handleDownloadAllDocuments;
  vm.handleGenerateDocument = _handleGenerateDocument;
  vm.handleCompleteAssessment = _handleCompleteAssessment;

  vm.handleGeneratePackage = _handleGeneratePackage;
  vm.handleDownloadPackage = _handleDownloadPackage;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    const dfdActivate = $q.defer(); // TODO: This does nothing; see below.

    _initPermissions();
    _initEventListeners();

    if (vm.assessment.documentId === null) {
      vm.assessment.documentId = 0;
    }

    if (vm.assessment.templateId === 1) {
      vm.frameworkName = 'CAT / ACET';
    } else {
      vm.frameworkName = 'CRI';
    }

    // TODO: Refactor this
    ecatSharedModelService.dfdGetTemplates.promise.then(() => {
      R.forEach((template, templateIndex) => {
        if (template.templateId === vm.assessment.templateId) {
          vm.template = template;
        }
        if (templateIndex === ecatSharedModelService.templates.length - 1) {
          dfdActivate.resolve(); // TODO: This does nothing; what is the intent?
        }
      }, ecatSharedModelService.templates);
    });
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('ecat').then(permissions => {
      vm.permissions = permissions;

      vm.canGenerateItemPackage = vm.permissions.canGeneratePackage;
      vm.canDownloadItemPackage = vm.permissions.canDownloadPackage && vm.assessment.hasAssessmentPackages;
    });
  }

  function _initEventListeners() {
    $scope.$on('refreshECATActiveAssessment', _refreshAssessment);

    $scope.$on('refreshECATInherentRiskProfile', (event, opt) => {
      if (opt.assessmentId === vm.assessment.assessmentId) {
        if (vm.assessment.inherentRiskProfile !== null && vm.assessment.inherentRiskProfile !== undefined) {
          vm.assessment.inherentRiskProfile.categories = null;
        }
        _refreshAssessmentInherentRiskProfile(true);
      }
    });
    $scope.$on('clearECATInherentRiskProfile', (event, opt) => {
      if (opt.assessmentId === vm.assessment.assessmentId) {
        vm.assessment.inherentRiskProfile.categories = null;
      }
    });

    $scope.$on('refreshECATMaturityProfile', (event, opt) => {
      if (opt.assessmentId === vm.assessment.assessmentId) {
        if (vm.assessment.maturityProfile !== null && vm.assessment.maturityProfile !== undefined) {
          vm.assessment.maturityProfile.maturityDomains = null;
        }
        _refreshAssessmentMaturityProfile(true);
      }
    });
    $scope.$on('clearECATMaturityProfile', (event, opt) => {
      if (opt.assessmentId === vm.assessment.assessmentId) {
        vm.assessment.maturityProfile.maturityDomains = null;
      }
    });

    $scope.$on('refreshECATAssessmentDocuments', (event, opt) => {
      if (opt.assessmentId === vm.assessment.assessmentId) {
        _refreshAssessmentDocuments();
      }
    });

    $scope.$on('refreshECATCRIProfile', (event, opt) => {
      if (opt.assessmentId === vm.assessment.assessmentId) {
        if (vm.assessment.criProfile !== null && vm.assessment.criProfile !== undefined) {
          vm.assessment.criProfile.criFunctions = null;
        }
        _refreshAssessmentCRIProfile(true);
      }
    });
    $scope.$on('clearECATCRIProfile', (event, opt) => {
      if (opt.assessmentId === vm.assessment.assessmentId) {
        vm.assessment.criProfile.criFunctions = null;
      }
    });
  }

  function _handleExpandAssessment() {
    vm.isExpanded = !vm.isExpanded;
  }

  function _handleGenerateDocument($event) {
    _showGenerateDocumentDialog($event);
  }

  function _handleCompleteAssessment($event) {
    return _showCompleteAssessmentDialog($event);
  }

  function _refreshAssessment() {
    loaderService.showViewLoader = true;

    const inherentRiskProfile = vm.assessment.inherentRiskProfile;
    const maturityProfile = vm.assessment.maturityProfile;

    return ecatDataService.getAssessment(vm.assessment.assessmentId).then(response => {
      vm.assessment = response.data;
      vm.assessment.inherentRiskProfile = inherentRiskProfile;
      vm.assessment.maturityProfile = maturityProfile;

      vm.documentsLoaded = true;
      loaderService.showViewLoader = false;
    });
  }

  function _refreshAssessmentInherentRiskProfile(refreshAssessment) {
    loaderService.showViewLoader = true;

    if (refreshAssessment) {
      const maturityProfile = vm.assessment.maturityProfile;

      $q.all([
        ecatDataService.getAssessment(vm.assessment.assessmentId),
        ecatDataService.getInherentRiskProfileByAssessment(vm.assessment.assessmentId),
      ]).then(response => {
        vm.assessment = response[0].data;
        vm.assessment.inherentRiskProfile = response[1].data;
        vm.assessment.maturityProfile = maturityProfile;

        vm.documentsLoaded = true;
        loaderService.showViewLoader = false;
      });
    } else {
      ecatDataService.getInherentRiskProfileByAssessment(vm.assessment.assessmentId).then(response => {
        vm.assessment.inherentRiskProfile = response.data;
        loaderService.showViewLoader = false;
      });
    }
  }

  function _refreshAssessmentMaturityProfile(refreshAssessment) {
    loaderService.showViewLoader = true;

    if (refreshAssessment) {
      vm.assessment.maturityProfile = [];
      const inherentRiskProfile = vm.assessment.inherentRiskProfile;

      $q.all([
        ecatDataService.getAssessment(vm.assessment.assessmentId),
        ecatDataService.getMaturityProfileByAssessment(vm.assessment.assessmentId),
      ]).then(response => {
        vm.assessment = response[0].data;
        vm.assessment.maturityProfile = response[1].data;
        vm.assessment.inherentRiskProfile = inherentRiskProfile;

        vm.documentsLoaded = true;
        loaderService.showViewLoader = false;
      });
    } else {
      vm.assessment.maturityProfile = [];
      ecatDataService.getMaturityProfileByAssessment(vm.assessment.assessmentId).then(response => {
        vm.assessment.maturityProfile = response.data;
        loaderService.showViewLoader = false;
      });
    }
  }

  function _refreshAssessmentCRIProfile(refreshAssessment) {
    loaderService.showViewLoader = true;

    if (refreshAssessment) {
      vm.assessment.criProfile = null;

      $q.all([
        ecatDataService.getAssessment(vm.assessment.assessmentId),
        ecatDataService.getCRIProfileByAssessment(vm.assessment.assessmentId),
      ]).then(response => {
        vm.assessment = response[0].data;
        vm.assessment.criProfile = response[1].data;

        vm.documentsLoaded = true;
        loaderService.showViewLoader = false;
      });
    } else {
      ecatDataService.getCRIProfileByAssessment(vm.assessment.assessmentId).then(response => {
        vm.assessment.criProfile = response.data;
        loaderService.showViewLoader = false;
      });
    }
  }

  function _refreshAssessmentDocuments() {
    loaderService.showViewLoader = true;
    return ecatDataService
      .getAssessmentDocumentsByAssessment(vm.assessment.assessmentId)
      .then(response => {
        vm.assessment.assessmentDocuments = response.data.result;
        vm.documentsLoaded = true;
        loaderService.showViewLoader = false;
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleExpandInherentRiskProfile() {
    vm.isInherentRiskProfileExpanded = !vm.isInherentRiskProfileExpanded;

    if (vm.isInherentRiskProfileExpanded) {
      _refreshAssessmentInherentRiskProfile(false);
    } else {
      vm.assessment.inherentRiskProfile.categories = null;
    }
  }

  function _handleExpandMaturityProfile() {
    vm.isMaturityProfileExpanded = !vm.isMaturityProfileExpanded;

    if (vm.isMaturityProfileExpanded) {
      _refreshAssessmentMaturityProfile(false);
    } else {
      vm.assessment.maturityProfile.maturityDomains = null;
    }
  }

  function _handleExpandCRIProfile() {
    vm.isCRIProfileExpanded = !vm.isCRIProfileExpanded;
    if (vm.isCRIProfileExpanded) {
      _refreshAssessmentCRIProfile(false);
    } else {
      vm.assessment.criProfile.criFunctions = null;
    }
  }

  function _handleEditInherentRiskProfile($event) {
    loaderService.showViewLoader = true;
    ecatDataService.getInherentRiskProfileByAssessment(vm.assessment.assessmentId).then(response => {
      ssDialogService.dialogs.ecat.editInherentRiskProfileDialog = ssDialogService.alert(
        editInherentRiskProfileDialog.getOptions($event, {
          assessmentId: vm.assessment.assessmentId,
          inherentRiskProfile: response.data,
        }),
      );
      ssDialogService.show(ssDialogService.dialogs.ecat.editInherentRiskProfileDialog);
      loaderService.showViewLoader = false;
    });
  }

  function _handleEditMaturityProfile($event) {
    loaderService.showViewLoader = true;
    ecatDataService.getMaturityProfileByAssessment(vm.assessment.assessmentId).then(response => {
      ssDialogService.dialogs.ecat.editMaturityProfileDialog = ssDialogService.alert(
        editMaturityProfileDialog.getOptions($event, {
          assessmentId: vm.assessment.assessmentId,
          maturityProfile: response.data,
        }),
      );
      ssDialogService.show(ssDialogService.dialogs.ecat.editMaturityProfileDialog);
      loaderService.showViewLoader = false;
    });
  }

  function _handleEditCRIProfile($event) {
    loaderService.showViewLoader = true;
    ecatDataService.getCRIProfileByAssessment(vm.assessment.assessmentId).then(response => {
      let _criProfile = response.data;
      ssDialogService.dialogs.ecat.editCRIProfileDialog = ssDialogService.alert(
        editCRIProfileDialog.getOptions($event, {
          assessmentId: vm.assessment.assessmentId,
          criProfile: _criProfile,
          assessment: vm.assessment,
        }),
      );
      ssDialogService.show(ssDialogService.dialogs.ecat.editCRIProfileDialog);
      loaderService.showViewLoader = false;
    });
  }

  function _handleEditAssessment($event) {
    loaderService.showViewLoader = true;
    $q.all([ecatDataService.getAssessment(vm.assessment.assessmentId), ecatDataService.getCustomerTemplates()]).then(
      response => {
        vm.hasData = true;
        vm.assessmentDetails = response[0].data;
        const templates = response[1].data.result;
        ssDialogService.dialogs.ecat.editAssessmentDialog = ssDialogService.alert(
          editAssessmentDialog.getOptions($event, {
            templates,
            assessment: vm.assessmentDetails,
          }),
        );
        ssDialogService.show(ssDialogService.dialogs.ecat.editAssessmentDialog);
        loaderService.showViewLoader = false;
      },
    );
  }

  function _handleDeleteAssessment($event) {
    ssDialogService.dialogs.ecat.deleteAssessmentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Assessment?',
        message: `Are you sure you want to delete assessment "${vm.assessment.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      }),
    );

    ssDialogService.show(ssDialogService.dialogs.ecat.deleteAssessmentConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    const assessmentId = vm.assessment.assessmentId;
    return ecatDataService
      .deleteAssessment(assessmentId)
      .then(() => {
        const assessment = $filter('filter')(ecatSharedModelService.assessments, { assessmentId })[0];
        ecatSharedModelService.assessments.splice(ecatSharedModelService.assessments.indexOf(assessment), 1);
        alerts.success('The assessment has been deleted successfully.');
        $rootScope.$broadcast('refreshECATAssessments');
        _closeDeleteDialog();
      })
      .catch(() => {
        alerts.error('An error occurred while deleting the assessment.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.ecat.deleteAssessmentConfirmDialog);
  }

  function _handleAttachDocument($event) {
    ecatDataService.getAssessmentDocumentTypes().then(response => {
      const documentTypes = response.data.result;
      ssDialogService.dialogs.ecat.editDocumentAttachmentDialog = ssDialogService.alert(
        editAssessmentDocumentDialog.getOptions($event, {
          assessment: vm.assessment,
          document: {
            assessmentDocumentId: 0,
            deletable: true,
          },
          documentTypes,
        }),
      );
      ssDialogService.show(ssDialogService.dialogs.ecat.editDocumentAttachmentDialog);
    });
  }

  function _handleDownloadAllDocuments() {
    loaderService.showViewLoader = true;
    ecatDataService.downloadAllAssessmentDocuments(vm.assessment.assessmentId).then(response => {
      _handleDownload(response);
    });
  }

  function _handleDownload(response) {
    alerts.success('The file download will start momentarily.');
    const contentDisposition = response.headers('Content-Disposition');

    if (!R.isNil(contentDisposition)) {
      const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/g.exec(contentDisposition);
      vm.downloadName = matches && matches.length > 1 ? matches[1] : null;
      vm.downloadName = vm.downloadName.split('"').join('');
    }

    const blob = new Blob([response.data], { type: 'application/x-zip-compressed' });

    // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, vm.downloadName);
    } else {
      const anchor = document.createElement('a');
      document.body.appendChild(anchor);
      anchor.setAttribute('type', 'hidden');

      anchor.href = URL.createObjectURL(blob);
      anchor.download = vm.downloadName;
      anchor.target = '_self';
      anchor.click();
    }

    loaderService.showViewLoader = false;
  }

  function _showGenerateDocumentDialog($event) {
    ssDialogService.dialogs.ecat.generateDocumentDialog = ssDialogService.alert(
      ecatGenerateDocumentDialog.getOptions($event, {
        assessment: vm.assessment,
      }),
    );
    ssDialogService.show(ssDialogService.dialogs.ecat.generateDocumentDialog);
  }

  function _showCompleteAssessmentDialog($event) {
    orgDataService.getSelectableUsers().then(response => {
      ssDialogService.dialogs.ecat.completeAssessmentConfirmDialog = ssDialogService.alert(
        confirmCompleteAssessmentDialog.getOptions($event, {
          assessmentId: vm.assessment.assessmentId,
          templateId: vm.assessment.templateId,
          assessmentName: vm.assessment.name,
          isNavantaUser: vm.isNavantaUser,
          users: response.data.result,
        }),
      );

      ssDialogService.show(ssDialogService.dialogs.ecat.completeAssessmentConfirmDialog);
    });
  }

  function _handleGeneratePackage() {
    return ecatDataService.createAssessmentPackageFileGenerationRequest(vm.assessment.assessmentId).then(() => {
      alerts.success(
        'The Assessment Package has been successfully requested. ' +
          'You will receive an email notification when the file generation is complete.',
      );
    });
  }

  function _handleDownloadPackage() {
    alerts.success('Download Package has been requested. Package download will start momentarily.');
    ecatDataService.downloadPackage(vm.assessment.assessmentPackages[0].assessmentPackageId).then(packageResponse => {
      ecatDataService.download(packageResponse);
    });
  }
}

ECATActiveAssessmentController.$inject = [
  '$filter',
  '$q',
  '$rootScope',
  '$scope',
  'confirmDialog',
  'copy',
  'orgDataService',
  'ecatDataService',
  'ecatSharedModelService',
  'reportsDataService',
  'loaderService',
  'editAssessmentDialog',
  'editInherentRiskProfileDialog',
  'editMaturityProfileDialog',
  'editCRIProfileDialog',
  'editAssessmentDocumentDialog',
  'performAssessmentDialog',
  'ecatGenerateDocumentDialog',
  'confirmCompleteAssessmentDialog',
  'ssDialogService',
  'userService',
  'alerts',
];
